import DoneIcon from "@mui/icons-material/Done";
import { Step, StepLabel, Stepper } from "@mui/material";
import { stepConnectorClasses } from "@mui/material/StepConnector";
import { stepLabelClasses } from "@mui/material/StepLabel";
import { useTheme } from "@mui/material/styles";
import React, { FC } from "react";

export interface StepperProps {
  steps: StepProps[];
  activeStepIndex: number;
}

interface StepProps {
  label: string;
  index: number;
}

const StepperComponent: FC<StepperProps> = ({ steps, activeStepIndex }) => {
  const theme = useTheme();

  const stepLabelSx = {
    [`&.${stepLabelClasses.root}`]: {
      flexDirection: "column",
      alignItems: "center",
    },
    [`& .${stepLabelClasses.labelContainer}`]: {
      margin: "0.5rem",
      textAlign: "center",
    },
    [`& .${stepConnectorClasses.root}`]: {
      marginBottom: theme.tokens.FuelSpacing12,
    },
    [`& .${stepLabelClasses.label}`]: {
      fontSize: theme.tokens.FuelFontSizeSm,
      fontWeight: `${theme.tokens.FuelFontWeightRegular} !important`,
    },
  };

  const renderIcon = (
    completed: boolean | undefined,
    icon:
      | React.ReactElement<any, string | React.JSXElementConstructor<any>>
      | string
      | number
      | Iterable<React.ReactNode>
      | React.ReactPortal
      | boolean
      | undefined
      | null
  ) => (completed ? <DoneIcon fontSize="small" /> : icon);

  return (
    <Stepper
      data-testid="stepper"
      activeStep={activeStepIndex}
      sx={{
        alignItems: "center",
        mx: theme.tokens.FuelSpacing4,
        [`& .${stepConnectorClasses.root}`]: {
          marginBottom: theme.tokens.FuelSpacing12,
        },
        [`& .${stepConnectorClasses.line}`]: {
          height: "1px",
        },
      }}
    >
      {steps.map((step) => (
        <Step key={step.index} index={step.index}>
          <StepLabel
            StepIconComponent={(props) => {
              // eslint-disable-next-line react/prop-types
              const { active, completed, icon } = props;
              const color =
                active || completed
                  ? theme.tokens.FuelColorBrandPrimary
                  : theme.tokens.FuelColorGray400;

              return (
                <div
                  style={{
                    backgroundColor: color,
                    color: "white",
                    borderRadius: "50%",
                    width: 25,
                    height: 25,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight: "normal",
                  }}
                >
                  {renderIcon(completed, icon)}
                </div>
              );
            }}
            sx={{
              ...stepLabelSx,
              [`&.${stepLabelClasses.active}`]: {
                color: theme.tokens.FuelColorBrandPrimary,
              },
              [`&.${stepLabelClasses.completed}`]: {
                color: theme.tokens.FuelColorBrandPrimary,
              },
              [`&.${stepLabelClasses.error}`]: {
                color: theme.tokens.FuelColorAlertErrorBorder,
              },
            }}
          >
            {step.label}
          </StepLabel>
        </Step>
      ))}
    </Stepper>
  );
};

export default StepperComponent;
